import LicenseFeatureAccessAbout, {
  type LicenseFeatureAccessAboutPoint,
} from "@/v2-backoffice-client/license/changes/LicenseFeatureAccessAbout"

// The three things a reader of the Capabilities view must know and cannot
// see in the rows: what a capability is, that the list is the app's own
// (declared in code, refreshed by every deploy, never edited here), and
// that every new one arrives free until this board decides. Behind "How it
// works", because the board is where a salesperson or a CSM meets the word
// "capability" for the first time, and the question "why can't I add one
// here?" comes up.
const POINTS: readonly LicenseFeatureAccessAboutPoint[] = [
  {
    key: "what",
    icon: "puzzle",
    lead: "A capability is a part of Fusion that can be switched on or off per customer",
    text: "a module in the sidebar, a tab in a panel, a tool on the map. Packages are made of capabilities (and map content); a license or an add-on carries packages; a customer is on a license.",
  },
  {
    key: "who",
    icon: "brackets-curly",
    lead: "Developers define them, in Fusion's code",
    text: "each gated component declares its capability (a feature code), and every deploy scans the code and refreshes this list. A capability appears here the moment its release lands; nothing can be added, renamed or split from Backoffice. That is a code change: ask a developer.",
  },
  {
    key: "decide",
    icon: "check-circle",
    lead: "Every new capability starts free for everyone",
    text: "the one decision per capability is who should have it: keep it free, or make it package-only and name the packages that include it, as many as apply. Open a capability to decide; the panel shows who would lose it before you save. The Packages column shows which packages already carry a capability: for a free one that is where it goes the day it is made package-only, and it changes nothing before then.",
  },
]

function LicenseChangesAbout() {
  return (
    <LicenseFeatureAccessAbout
      lead="Every new capability arrives free for every customer. Open one to keep it free or make it package-only."
      points={POINTS}
    />
  )
}

export default LicenseChangesAbout
